import { get } from 'lodash';

function PageTitle($q) {
  'ngInject';

  return {
    requestTitle,
  };

  /**
   * @param {Transition} tr
   * @returns {Promise<[String]>}
   */
  function requestTitle(tr) {
    const fallbackTitle = get(tr.to(), 'data.title', null);
    return $q.when(_formatTitle(fallbackTitle));
  }

  /**
   * @param {String=} pageName
   * @returns {String}
   * @private
   */
  function _formatTitle(pageName) {
    const adjustName = 'adjust';
    return pageName ? `${t(pageName)} | ${adjustName}` : adjustName;
  }
}

export { PageTitle };
